var path = 'app/templates/partials/footer.html';
var html = "<footer class=\"main-footer\">\n    <p>Contact us <a href=\"mailto:support@hmrreferrals.com.au\">support@hmrreferrals.com.au</a><br>\n        <a href=\"tel:+61390363960\"><strong>(03) 9036 3960</strong></a></p>\n</footer>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/templates/partials/footer.html
 ** module id = 127
 ** module chunks = 0
 **/